import { gql } from "@apollo/client";

export const getSupportedLensSourceTypes = gql`
    query getSupportedLensSourceTypes($organizationId: String) {
        getSupportedLensSourceTypes(input: { organizationId: $organizationId }) {
            lensSourceTypes
        }
    }
`;
